/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* ==========================================================================
   SEO — Limpieza de parametros vacios en URLs de coleccion
   Anadido: 2026-08-18

   Problema: al filtrar, el tema serializa el formulario completo y arrastra
   los inputs de precio vacios y un sort_by que no cambia el orden servido:
     ?sort_by=most-relevant&filter.v.price.gte=&filter.v.price.lte=&filter...

   Solucion: envolvemos history.pushState/replaceState (que es lo que usa el
   tema para actualizar la URL al filtrar) y quitamos esos parametros. No se
   toca assets/theme.js.

   Para revertir: borrar este bloque completo.
   ========================================================================== */
(function () {
  'use strict';

  // Solo colecciones y busqueda. En ficha de producto no tocamos nada,
  // porque el tema usa _pos/_sid/_ss para la navegacion entre resultados.
  var ruta = window.location.pathname;
  if (ruta.indexOf('/collections/') === -1 && ruta.indexOf('/search') === -1) return;

  // Valores de sort_by que no alteran el orden que sirve Shopify en coleccion.
  var SORT_INUTILES = ['', 'manual', 'most-relevant', 'relevance'];

  function limpiar(entrada) {
    var url;
    try {
      url = new URL(entrada, window.location.origin);
    } catch (e) {
      return entrada;
    }

    var params = url.searchParams;
    var aBorrar = [];

    // filter.v.price.gte=&filter.v.price.lte= y cualquier filtro sin valor
    params.forEach(function (valor, clave) {
      if (clave.indexOf('filter.') === 0 && valor.trim() === '') aBorrar.push(clave);
    });

    if (SORT_INUTILES.indexOf(params.get('sort_by')) !== -1) aBorrar.push('sort_by');
    if (params.get('page') === '1') aBorrar.push('page');

    if (!aBorrar.length) return entrada;

    aBorrar.forEach(function (clave) { params.delete(clave); });

    var query = params.toString();
    return url.pathname + (query ? '?' + query : '') + url.hash;
  }

  ['pushState', 'replaceState'].forEach(function (metodo) {
    var original = window.history[metodo];
    window.history[metodo] = function (estado, titulo, destino) {
      var limpio = (destino === undefined || destino === null) ? destino : limpiar(String(destino));
      return original.call(window.history, estado, titulo, limpio);
    };
  });

  // Limpia tambien la URL con la que se ha cargado la pagina.
  var actual = ruta + window.location.search + window.location.hash;
  var limpia = limpiar(actual);
  if (limpia !== actual) {
    window.history.replaceState(window.history.state, '', limpia);
  }
})();
